import * as SuiteApiClient from '../openapi-clients-generated/suite';
import { configureApiClient } from './helpers';

export const apiClient = new SuiteApiClient.ApiClient({
    BASE: import.meta.env.VITE_APP_API_URL
});
configureApiClient(apiClient, SuiteApiClient.CancelablePromise);
